import { serviceMaker } from "..";
import { IActiveInactive, IPagination } from "../../data/AppInterface";
import { IFirmAdvancedSearch } from "../../screens/firm/FirmListController";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

export const GET_ALL_FIRM = (
  pagination: IPagination,
  search: string,
  advanceSearch: IFirmAdvancedSearch
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_firm.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }${
        advanceSearch.firm_type.length > 0
          ? `&firm_type=${advanceSearch.firm_type}`
          : ""
      }&is_deleted=${advanceSearch.is_deleted}`,
    API_ENDPOINTS.get_all_firm.method
  );

export const DELETE_FIRM = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_firm.url + `/${id}`,
    API_ENDPOINTS.delete_firm.method
  );
};

export const ACTIVE_INACTIVE_FIRM = async (
  id: string,
  activeInactiveValue: IActiveInactive
) => {
  return serviceMaker(
    API_ENDPOINTS.active_inactive_firm.url + `/${id}`,
    API_ENDPOINTS.active_inactive_firm.method,
    activeInactiveValue
  );
};

export const GET_FIRM_BY_ID = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.get_all_firm.url + `/${id}`,
    API_ENDPOINTS.get_all_firm.method
  );
};
